import { DocumentIncomeRequirementFileType, DocumentIncomeRequirements } from '@frame/lib/api/tasks/types'

export function requirementTypeIncluded(
  documentIncomeRequirements: DocumentIncomeRequirements,
  fileType: DocumentIncomeRequirementFileType
) {
  return documentIncomeRequirements.requirements.some((req) => req.file_type === fileType)
}

export function shouldHideW2s(documentIncomeRequirements?: DocumentIncomeRequirements | null): boolean {
  if (!documentIncomeRequirements) {
    return false
  }

  return !requirementTypeIncluded(documentIncomeRequirements, DocumentIncomeRequirementFileType.W2)
}
